module.exports = "<div class=\"circularChart --{{$ctrl.value}}\"\r\n     ng-if=\"$ctrl.type === 'circle'\">\r\n   <div class=\"circularChart__overlay\"></div>\r\n</div>\r\n<div ng-if=\"$ctrl.type === 'linear'\"\r\n     class=\"linearChart\">\r\n   <div class=\"--{{$ctrl.value}}\"></div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/progress-chart/progress-chart.html
// module id = 1825
// module chunks = 0